import { render, staticRenderFns } from "./ReportCaracterizacion.vue?vue&type=template&id=bf825070"
import script from "./ReportCaracterizacion.vue?vue&type=script&lang=js"
export * from "./ReportCaracterizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports